function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { createContext, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { I18nextProvider, initReactI18next } from "react-i18next";
import numbro from "numbro";
import i18n from "i18next";
import { thunkOptions } from "../../providers/reduxProvider";
import { setDateFnsLocale } from "./useDateFnsLocale";
import { configSelectors } from "../../redux/config";
// BUNDLE THE DEFAULT LOCALE IN THE INITIAL CHUNK
var defaultLocale = "ro-RO";
import numbroRO from "numbro/languages/ro-RO";
import { ro as dateFnsRO } from "date-fns/locale";
import appLocaleRO from "../../../resources/lang/ro-RO.json";
import { getLocalStorageItem, setLocalStorageItem } from "../app/utils";
export var LanguageLoaderContext = /*#__PURE__*/ createContext(null);
LanguageLoaderProvider.propTypes = {
    children: PropTypes.node.isRequired
};
export default function LanguageLoaderProvider(param) {
    var children = param.children;
    var _useState = _sliced_to_array(useState(true), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    var locale = defaultLocale;
    var possibleLocales = useSelector(configSelectors.locales);
    if (getLocalStorageItem("locale") && possibleLocales.includes(getLocalStorageItem("locale"))) {
        locale = getLocalStorageItem("locale");
    }
    var debug = useSelector(configSelectors.debug);
    var i18nInstance = useMemo(function() {
        var i18nInstance = i18n.createInstance();
        thunkOptions.i18n = i18nInstance;
        return i18nInstance;
    }, []);
    useEffect(function() {
        loadLanguage({
            locale: locale,
            debug: debug,
            i18n: i18nInstance
        }).then(function() {
            return setIsLoading(false);
        });
    }, []);
    if (isLoading) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(LanguageLoaderContext.Provider, {
        value: function(newLocale) {
            return loadLanguage({
                locale: newLocale,
                debug: debug,
                i18n: i18nInstance
            });
        }
    }, /*#__PURE__*/ React.createElement(I18nextProvider, {
        i18n: i18nInstance
    }, children));
}
export function loadLanguage(_) {
    return _loadLanguage.apply(this, arguments);
}
function _loadLanguage() {
    _loadLanguage = _async_to_generator(function(param) {
        var locale, debug, i18n, _ref, catalog, dateFns, numbroLocale;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    locale = param.locale, debug = param.debug, i18n = param.i18n;
                    return [
                        4,
                        loadLocales(locale)
                    ];
                case 1:
                    _ref = _state.sent(), catalog = _ref.app, dateFns = _ref.dateFns, numbroLocale = _ref.numbro;
                    /**
     * Set the catalog to i18n
     */ return [
                        4,
                        i18n.use(initReactI18next) // passes i18n down to react-i18next
                        .init({
                            load: "currentOnly",
                            lng: locale,
                            resources: {},
                            fallbackLng: defaultLocale,
                            debug: debug,
                            interpolation: {
                                escapeValue: false
                            },
                            returnNull: false
                        })
                    ];
                case 2:
                    _state.sent();
                    numbro.registerLanguage(numbroLocale, true);
                    setDateFnsLocale(dateFns);
                    i18n.addResourceBundle(locale, "translation", catalog);
                    return [
                        4,
                        i18n.changeLanguage(locale)
                    ];
                case 3:
                    _state.sent();
                    setLocalStorageItem("locale", locale);
                    return [
                        2
                    ];
            }
        });
    });
    return _loadLanguage.apply(this, arguments);
}
function loadLocales(locale) {
    return _loadLocales.apply(this, arguments);
}
function _loadLocales() {
    _loadLocales = _async_to_generator(function(locale) {
        var dateFnsLoader, appLocalesLoader, numbroLoader, ref, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        6,
                        ,
                        7
                    ]);
                    switch(locale){
                        case "en-GB":
                            return [
                                3,
                                1
                            ];
                        case "ro-RO":
                            return [
                                3,
                                3
                            ];
                    }
                    return [
                        3,
                        4
                    ];
                case 1:
                    return [
                        4,
                        Promise.all([
                            import("numbro/languages/en-GB"),
                            import("date-fns/locale/en-GB").then(function(module) {
                                return {
                                    default: module.enGB
                                };
                            }),
                            import("../../../resources/lang/en-GB.json")
                        ])
                    ];
                case 2:
                    ref = _sliced_to_array.apply(void 0, [
                        _state.sent(),
                        3
                    ]), numbroLoader = ref[0], dateFnsLoader = ref[1], appLocalesLoader = ref[2], ref;
                    return [
                        3,
                        5
                    ];
                case 3:
                    numbroLoader = {
                        default: numbroRO
                    };
                    appLocalesLoader = {
                        default: appLocaleRO
                    };
                    dateFnsLoader = {
                        default: dateFnsRO
                    };
                    return [
                        3,
                        5
                    ];
                case 4:
                    throw new Error("Invalid locale ".concat(locale));
                case 5:
                    return [
                        3,
                        7
                    ];
                case 6:
                    e = _state.sent();
                    numbroLoader = {
                        default: numbroRO
                    };
                    appLocalesLoader = {
                        default: appLocaleRO
                    };
                    dateFnsLoader = {
                        default: dateFnsRO
                    };
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2,
                        {
                            dateFns: dateFnsLoader.default,
                            app: appLocalesLoader.default,
                            numbro: numbroLoader.default
                        }
                    ];
            }
        });
    });
    return _loadLocales.apply(this, arguments);
}
